var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.67 16.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.83,16.67h-3.33c-.67,0-1.3-.26-1.77-.73s-.73-1.1-.73-1.77V2.5c0-.67.26-1.3.73-1.77s1.1-.73,1.77-.73h3.33c.46,0,.83.37.83.83s-.37.83-.83.83h-3.33c-.22,0-.43.09-.59.24s-.24.37-.24.59v11.67c0,.22.09.43.24.59s.37.24.59.24h3.33c.46,0,.83.37.83.83s-.37.83-.83.83Zm5.83-3.33c-.21,0-.43-.08-.59-.24-.33-.33-.33-.86,0-1.18l2.74-2.74h-7.98c-.46,0-.83-.37-.83-.83s.37-.83.83-.83h7.98l-2.74-2.74c-.33-.33-.33-.85,0-1.18s.86-.33,1.18,0l4.17,4.17s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0c.08.08.14.17.18.27.04.09.06.19.06.3h0v.04h0c0,.11-.02.21-.06.3-.04.1-.1.19-.17.27h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0h0s-4.16,4.17-4.16,4.17c-.16.16-.38.24-.59.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.4df733ba0a83fb1bd98c145367170520.svg";
export { ForwardRef as ReactComponent };